/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { HtmlStringDisplayer } from '../../../../utils/HtmlStringDisplayer';

const defaultWelcomeMessageText =
  'Clinical knowledge hub is designed to consolidate clinical guidance for providers and facilitate navigation of referrals and clinical expertise. It is not meant to replace your clinical judgement as a provider.';

export function useWelcomeMessageText() {
  return defaultWelcomeMessageText;
}

export function WelcomeMessage() {
  const msg = useWelcomeMessageText();
  return msg.length ? <HtmlStringDisplayer html={msg}></HtmlStringDisplayer> : null;
}
